import { render, staticRenderFns } from "./HeroList.vue?vue&type=template&id=775580df&lang=pug"
import script from "./HeroList.vue?vue&type=script&lang=js"
export * from "./HeroList.vue?vue&type=script&lang=js"
import style0 from "./HeroList.vue?vue&type=style&index=0&id=775580df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports